var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconScan(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_234_272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70 0H10C4.47715 0 0 4.47715 0 10V70C0 75.5229 4.47715 80 10 80H70C75.5229 80 80 75.5229 80 70V10C80 4.47715 75.5229 0 70 0Z",
    fill: "url(#paint0_linear_234_272)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.755 24.1648C23 25.2406 23 28.4381 23 34.8334V37.9828C23 49.2588 31.4779 54.731 36.7971 57.0546C38.24 57.6848 38.9614 58 41 58C43.0386 58 43.76 57.6848 45.2028 57.0546C50.522 54.731 59 49.2588 59 37.9828V34.8334C59 28.4381 59 25.2406 58.245 24.1648C57.49 23.0891 54.4834 22.0599 48.4702 20.0016L47.3246 19.6094C44.19 18.5365 42.6228 18 41 18C39.3772 18 37.81 18.5365 34.6754 19.6094L33.5298 20.0016C27.5166 22.0599 24.5101 23.0891 23.755 24.1648ZM38.7226 30.7267L38.4604 31.197C38.1724 31.7135 38.0284 31.9718 37.804 32.1422C37.5794 32.3127 37.2998 32.3759 36.7407 32.5024L36.2316 32.6176C34.2639 33.0628 33.28 33.2855 33.0459 34.0382C32.8119 34.791 33.4826 35.5752 34.8241 37.144L35.1711 37.5498C35.5523 37.9956 35.7429 38.2184 35.8287 38.4942C35.9144 38.77 35.8856 39.0672 35.828 39.662L35.7755 40.2036C35.5727 42.2964 35.4713 43.343 36.0841 43.8082C36.6969 44.2734 37.6182 43.8492 39.4606 43.001L39.9372 42.7814C40.4608 42.5404 40.7226 42.4198 41 42.4198C41.2774 42.4198 41.5392 42.5404 42.0628 42.7814L42.5394 43.001C44.3818 43.8492 45.303 44.2734 45.9158 43.8082C46.5288 43.343 46.4272 42.2964 46.2244 40.2036L46.172 39.662C46.1144 39.0674 46.0856 38.77 46.1714 38.4942C46.257 38.2184 46.4476 37.9956 46.8288 37.5498L47.176 37.144C48.5174 35.5752 49.1882 34.791 48.954 34.0382C48.72 33.2855 47.7362 33.0628 45.7684 32.6176L45.2592 32.5024C44.7002 32.3759 44.4206 32.3127 44.196 32.1422C43.9716 31.9718 43.8276 31.7136 43.5396 31.197L43.2774 30.7267C42.2642 28.9089 41.7574 28 41 28C40.2426 28 39.7358 28.9089 38.7226 30.7267Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_234_272",
    x1: -9.5,
    y1: 83,
    x2: 49.9974,
    y2: -15.1554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#633F89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501045,
    stopColor: "#273E9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0721C8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_234_272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScan);
export default __webpack_public_path__ + "static/media/icon_scan.a4afe282a9da886b9074cd2a5698cea4.svg";
export { ForwardRef as ReactComponent };